import React, { useEffect, useContext } from "react";
import { Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";

const NoResultsInDataGrid = () => {
  const rootStore = useContext(RootStoreContext);
  const { alertError } = rootStore.alertStore;

  useEffect(() => {
    alertError("No se encontraron resultados");
  }, []);

  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      No se encontraron resultados
    </Stack>
  );
};

export default observer(NoResultsInDataGrid);
